export { default as isPersistentTaskpaneEnabled } from './selectors/isPersistentTaskpaneEnabled';
export { default as isAddinComplianceVerificationEnabled } from './selectors/isAddinComplianceVerificationEnabled';
